const entityHexColourCache: { [key: string]: string } = {};
const firmHexColourCache: { [key: string]: string } = {};

export { entityHexColourCache, firmHexColourCache };
